import React, { Fragment, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilos from '../../UsuarioInspectorEnCampo/Asociados/PanelAsociadoComponent.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { ObtenerClientes } from '../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import { iniciarSesion, obtenerLotesRebeca } from '../../../redux/DucksUnidadInspeccion/RebeckaDuck';
import { obtenerLotesEnvasado, obtenerLotesGranelEnvasado, obtenerLotesGranelFabrica, obtenerLotesProduccion } from '../../../redux/DucksUnidadInspeccion/TrazabilidadDuck';
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import VisualizarTrazabilidad from './VisualizarTrazabilidad';

function TableBusquedaLotesComponent(props) {

    const dispatch = useDispatch()

    const clientes = useSelector(store => store.ModuloConsulta.clientes);

    const [cajaBusqueda, setcajaBusqueda] = React.useState('');
    const [clientesFiltrados, setClientesFiltrados] = React.useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = React.useState(1);
    const [opcionesOcultas, setOpcionesOcultas] = React.useState(true);

    const [lotesRebeca, setLotesRebeca] = React.useState([]);

    const [lotesFiltrados, setLotesFiltrados] = React.useState([]);

    const [todosLotes, setTodosLotes] = React.useState([])

    const [loteSeleccionado, setLoteSeleccionado] = React.useState(null);

    const [resultado, setResultado] = React.useState(false)

    const [enabledBusqueda, setEnabledBusqueda] = React.useState(true)

    const [tipoBusqueda, setTipoBusqueda] = React.useState()

    React.useEffect(() => {
        dispatch(ObtenerClientes())   //clientes //clientes     
    }, []);


    React.useEffect(() => {
        var expresionRegular = /[\[\]\(\)\{\};,.<>=!&|+\-*\/%~^?:"'\\]/;
        if (cajaBusqueda != '') {
            setOpcionesOcultas(false);
            //DOS CASOS
            //|1| SI ES POR NÚMERO DE SOCIO
            if (!isNaN(cajaBusqueda)) {
                setLotesFiltrados([])
                setClientesFiltrados(clientes?.filter(c => c.numerosocio.toUpperCase().includes(cajaBusqueda.toUpperCase())));
                setResultado(true)
            }
            else {
                //|2| SI ES POR RAZÓN SOCIAL
                setLotesFiltrados([])
                setClientesFiltrados(clientes?.filter(c => c.nombrerazonsocial.toUpperCase().includes(cajaBusqueda.toUpperCase())));
                setResultado(true)
            }
            if (clientesFiltrados.length > 0) {
                setClienteSeleccionado(clientesFiltrados[0]);
            }
        } else if (cajaBusqueda.length === 0) {
            setOpcionesOcultas(true);
        }
        else {
            instalaciones = []
        }

    }, [cajaBusqueda])

    const handleBuscarInstalaciones = (event) => {
        setcajaBusqueda(event.target.value);
    }

    const handleElegirCliente = (cliente) => {
        if (cajaBusqueda != '') {
            setcajaBusqueda(cliente.nombrerazonsocial);
            setClienteSeleccionado(cliente);
            //dispatch(getInstalacionesByCliente(cliente.idcliente));
        } else {
            alert('Ingrese un número de cliente o razón social');
        }
    }

    React.useEffect(() => {
        if (clienteSeleccionado.numerosocio != undefined) {
            if (tipoBusqueda == 1) {
                dispatch(obtenerLotesProduccion(clienteSeleccionado.numerosocio)).then((res) => {
                    let aux = []
                    res.payload.data.response.forEach(element => {
                        aux.push(element.Producciones[0])
                    });
                    setLotesRebeca(aux)
                    setLotesFiltrados(aux)
                })
            } else if (tipoBusqueda == 2) {
                dispatch(obtenerLotesGranelFabrica(clienteSeleccionado.numerosocio)).then((res) => {

                    let aux = []
                    res.payload.data.response.forEach(element => {
                        aux.push(element.GranelesFabrica[0])
                    });
                    
                    setLotesRebeca(aux)
                    setLotesFiltrados(aux)
                })

            } else if (tipoBusqueda == 3) {
                dispatch(obtenerLotesGranelEnvasado(clienteSeleccionado.numerosocio)).then((res) => {
                    let aux = []
                    res.payload.data.response.forEach(element => {
                        aux.push(element.GranelesEnvasado[0])
                    });
                    console.log(aux)
                    setLotesRebeca(aux)
                    setLotesFiltrados(aux)
                })
            } else if (tipoBusqueda == 4) {
                dispatch(obtenerLotesEnvasado(clienteSeleccionado.numerosocio)).then((res) => {
                    let aux = []
                    res.payload.data.response.forEach(element => {
                        aux.push(element.Envasado[0])
                    });
                    console.log(aux)
                    setLotesRebeca(aux)
                    setLotesFiltrados(aux)
                })
            }
        }
    }, [tipoBusqueda])

    function obtenerRazonSocial(noCliente) {
        let cliente = clientes.filter(c => c.numerosocio == noCliente)
        if (cliente.length > 0) {
            return cliente[0].nombrerazonsocial
        }
    }

    const [openVisualizar, setOpenVisualizar] = React.useState(false);

    const handleOpenVisualizar = (l) => {
        setLoteSeleccionado(l)
        setOpenVisualizar(true)
    }

    const handleCloseVisualizar = () => {
        setOpenVisualizar(false)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const modalVisualizar = () => {
        return (
            <Fragment>
                {
                    <Modal
                        open={openVisualizar}
                        onClose={handleCloseVisualizar}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <VisualizarTrazabilidad trazabilidad={loteSeleccionado} tipoBusqueda={tipoBusqueda}></VisualizarTrazabilidad>
                        </Box>

                    </Modal>
                }
            </Fragment>

        )
    }

    return (
        <Fragment><br />
            <div className="container">
                <div className='row'>
                    <div>
                        <div className="d-flex" role="search">
                            <input className="form-control me-2" type="search" name='busqueda'
                                placeholder="Ingrese el número de cliente, razón social, o lote ..."
                                aria-label="Search" onChange={handleBuscarInstalaciones} value={cajaBusqueda} />
                        </div>

                        <div hidden={opcionesOcultas}>

                            {
                                clientesFiltrados.map((i, index) => (

                                    <p className={`${estilos.opciones}`} onClick={() => handleElegirCliente(i)} key={index}><strong>( {i.numerosocio} )</strong> {i.nombrerazonsocial}</p>
                                ))
                            }
                        </div>
                        <hr />
                        <div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" onClick={() => setTipoBusqueda(1)} />
                                <label className="form-check-label" htmlFor="flexRadioDefault1">
                                    Producción
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onClick={() => setTipoBusqueda(2)} />
                                <label className="form-check-label" htmlFor="flexRadioDefault2">
                                    Graneles de Fábrica
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onClick={() => setTipoBusqueda(3)} />
                                <label className="form-check-label" htmlFor="flexRadioDefault2">
                                    Graneles de Envasado
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onClick={() => setTipoBusqueda(4)} />
                                <label className="form-check-label" htmlFor="flexRadioDefault2">
                                    Envasado
                                </label>
                            </div>
                        </div>
                    </div>
                    <br />
                    <hr />
                    {
                        resultado == true ?
                            <p>Lotes del cliente: <strong>( {clienteSeleccionado.numerosocio} ) </strong>  {clienteSeleccionado.nombrerazonsocial}</p>
                            :
                            <Fragment></Fragment>
                    }
                    <div className='table-responsive'>
                        <table className='table table-striped table-hover'>
                            <thead>
                                <tr>
                                    <th>ID:</th>
                                    <th>Estatus:</th>
                                    <th>Fecha de Registro:</th>
                                    <th>Inspector:</th>
                                    <th>Acciones:</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    lotesFiltrados.map((l, index) => {
                                        return (
                                            tipoBusqueda == 1 ?
                                                <tr key={index}>
                                                    {
                                                        <Fragment>
                                                            <td>{l?.id}</td>
                                                            <td>{l?.estatus}</td>
                                                            <td>{l?.fechaRegistro}</td>
                                                            <td>{l?.inspector}</td>
                                                            <td>
                                                                <button className='btn btn-sm btn-success' onClick={() => { handleOpenVisualizar(l) }}>Opciones</button>
                                                            </td>
                                                        </Fragment>
                                                    }


                                                </tr>
                                                :
                                                tipoBusqueda == 2 ?
                                                    <tr key={index}>
                                                        {
                                                            <Fragment>
                                                                <td>{l?.id}</td>
                                                                <td>{l?.estatus}</td>
                                                                <td>{l?.fechaRegistro}</td>
                                                                <td>{l?.inspector}</td>
                                                                <td>
                                                                    <button className='btn btn-sm btn-success' onClick={() => { handleOpenVisualizar(l) }}>Opciones</button>
                                                                </td>
                                                            </Fragment>
                                                        }
                                                    </tr>
                                                    :
                                                    tipoBusqueda == 3 ?
                                                        <Fragment></Fragment>
                                                        :
                                                        tipoBusqueda == 4 ?
                                                            <Fragment></Fragment>
                                                            :
                                                            <Fragment></Fragment>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            {modalVisualizar()}
        </Fragment>
    );
};


export default withRouter(TableBusquedaLotesComponent)
